import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * CW-13g (AD-042) — Digits-only phone validator.
 *
 * The phone-number control now collects digits ONLY (no `+`, no
 * spaces, no parentheses). The international dialing code lives on
 * a sibling `dialingCode` control. On submit the two are concatenated
 * to produce the E.164 string `+{dialingCode}{phoneDigits}` that the
 * backend `RegisterPersonal/CorporateDto.phoneNumber` accepts.
 *
 * Allowed: 4–15 digits. Empty values are deferred to `Validators.required`.
 */
const PHONE_DIGITS_REGEX = /^[0-9]{4,15}$/;

export const phoneDigitsValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  const value = control.value;
  if (value === null || value === undefined || value === '') {
    return null;
  }
  if (typeof value !== 'string') {
    return { phoneDigits: true };
  }
  return PHONE_DIGITS_REGEX.test(value) ? null : { phoneDigits: true };
};

/**
 * CW-13g — Dialing-code validator. Accepts `+` followed by 1–4 digits
 * (e.g. `+44`, `+1`, `+421`). Empty values are deferred to
 * `Validators.required`.
 */
const DIALING_CODE_REGEX = /^\+[0-9]{1,4}$/;

export const dialingCodeValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  const value = control.value;
  if (value === null || value === undefined || value === '') {
    return null;
  }
  if (typeof value !== 'string') {
    return { dialingCode: true };
  }
  return DIALING_CODE_REGEX.test(value) ? null : { dialingCode: true };
};
